import _from                               from './from';
import _to                                 from './to';
import type { Types                           } from './types';

export class AdmentumMap {
  static to   = _to;
  static from = _from;
}

export { Types as AdmentumTypes };
